import ParameterValidator from './lib/ParameterValidator';

export default ParameterValidator;
